module.exports = __webpack_public_path__ + "static/media/desosaiLogo.b371194e.png";